import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import AddressAutosuggest from '../../components/AddressAutosuggest/AddressAutosuggest';
import { logEventAddressSelectedInLiveDeparture } from '../../services/AnalyticsService';
import { RECENT_ADDRESS_LIST_STORAGE_KEYS, saveRecentSearch } from '../../services/AddressService';
import LiveDepartureActions from '../../redux/LiveDeparture';

class StopInputContainer extends React.Component {
  constructor(props) {
    super(props);
    this.onAddressSelected = this.onAddressSelected.bind(this);
    this.onAddressCleared = this.onAddressCleared.bind(this);

    const { location, selectAddress } = props;
    const query = new URLSearchParams(location.search);
    if (query.get('address')) {
      const address = {
        name: query.get('name'),
        displayText: query.get('displayText'),
        address: query.get('displayText') ?? query.get('address'),
        category: query.get('category'),
        lat: query.get('lat'),
        lng: query.get('lng'),
      };

      saveRecentSearch(RECENT_ADDRESS_LIST_STORAGE_KEYS.LIVE_DEPARTURES, address);
      selectAddress(address);
    }
  }

  onAddressSelected(address) {
    logEventAddressSelectedInLiveDeparture(address);
    const { selectAddress } = this.props;
    selectAddress(address);
  }

  onAddressCleared() {
    const { selectAddress } = this.props;
    selectAddress(null);
  }

  onStopTextChange = (newValue) => {
    const { setText } = this.props;
    setText(newValue);
  };

  render() {
    const { text } = this.props;
    return (
      <div className="at-flex-grid">
        <div className="row">
          {/* eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */}
          <label htmlFor="ld-address-input-autosuggest" id="address-input-label" className="address-input-label col-xs-10 col-sm-6 col-xs-offset-1 col-sm-offset-3">
            Search for a stop
          </label>
        </div>
        <div className="row">
          <div className="col-xs-10 col-sm-6 col-xs-offset-1 col-sm-offset-3 stop-input-container">
            <AddressAutosuggest
              id="ld-address-input-autosuggest"
              storageKey={RECENT_ADDRESS_LIST_STORAGE_KEYS.LIVE_DEPARTURES}
              hasFindOnMap
              placeholder="Location or stop number"
              onAddressDetermined={this.onAddressSelected}
              onAddressCleared={this.onAddressCleared}
              onTextChange={this.onStopTextChange}
              value={text}
            />
          </div>
        </div>
      </div>
    );
  }
}

StopInputContainer.defaultProps = {
  selectAddress: () => { /* default empty function */ },
  text: '',
};
StopInputContainer.propTypes = {
  text: PropTypes.string,
  selectAddress: PropTypes.func,
  setText: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = ({ liveDeparture }) => ({
  text: liveDeparture.text,
});
const mapDispatchToProps = dispatch => ({
  selectAddress: address => dispatch(LiveDepartureActions.selectAddress(address)),
  setText: text => dispatch(LiveDepartureActions.setText(text)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StopInputContainer));
